import React, { useState } from 'react';
import { Stack, TextField, Button, Alert } from '@mui/material';
import PropTypes from 'prop-types';
import { backendAuthenticate } from '../backend/backend';

const Login = ({setToken}) => {
	const [username,setUsername]=useState();
	const [password,setPassword]=useState();
	const [failedLogin,setFailedLogin]=useState(false);

	const handleSubmit = async () => {
		const authRecord=await backendAuthenticate(username,password);
		if (authRecord==null) {
			console.log("Login failed!");
			setFailedLogin(true);
		} else {
			setToken(authRecord.token);
		}
	}

	const handleKeyPress = (e) => {
		if (e.key==='Enter') {
			handleSubmit();
		}
	}

	return(
		<Stack>
			<TextField label="Username" onChange={e => setUsername(e.target.value)} variant="outlined" autoFocus={true}/>
			<TextField label="Password" onChange={e => setPassword(e.target.value)} variant="outlined" type="password" onKeyPress={handleKeyPress}/>
			<Button onClick={handleSubmit} variant="contained">Submit</Button>
			{failedLogin && <Alert variant="filled" severity="error" icon={false}>Incorrect username or password</Alert>}
		</Stack>
	);
}

Login.propTypes = {
	setToken: PropTypes.func.isRequired
};

export default Login;
